import { LoggerService } from '@mews/framework';

interface LogIframedUrlOptions {
    contextWindow: Window;
    loggerService: LoggerService;
}

export const logIframedUrl = ({ contextWindow, loggerService }: LogIframedUrlOptions) => {
    let topWindowHref = null;
    let error = null;
    try {
        topWindowHref = contextWindow.top?.location.href;
    } catch (e) {
        error = e;
    }

    loggerService.log('app-loaded-in-iframe', 'App is loaded in iframe', {
        topWindowHref,
        error,
    });
};
